module.exports = __webpack_public_path__ + "img/product16.9295a863.jpg";